<div class="container">
  <form [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'filter.configuration_name' | translate }}</mat-label>
      <input matInput formControlName="filterConfigName" placeholder="Name" />
    </mat-form-field>
  </form>
  <button mat-raised-button color="warn" (click)="cancel()">{{ 'button.cancel' | translate }}</button>
  <button mat-raised-button color="primary" (click)="submit()">{{ 'button.save' | translate }}</button>
</div>
